<div class="d-grid justify-content-center text-center h-100 align-items-center">
    <div>
        <div class="f-bold mb-2">
            <mwp-text-translate text="Page Not Found!" jsonKey="pageNotFound" />
        </div>
        <div>
            <button (click)="redirectHome()" class="mwp-button">
                <span>{{redirectLabel}}</span>
            </button>
        </div>
    </div>
</div>